
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/baremetal",
      function () {
        return require("private-next-pages/baremetal.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/baremetal"])
      });
    }
  